import { network } from 'services/network';

import { QueryResponse as Tag } from 'api/queries/getReportsTags.query';

export const getReportAccessStatus = (params: QueryParams): Promise<QueryResponse> => {
    const url = `api/bo/reporting/getReportAccessStatus`;
    return network.post<QueryResponse>(url, params).then((response) => {
        return response.data;
    });
};

export interface QueryParams {
    id: number;
}

export interface QueryResponse {
    reportId: number;
    reportAccessStatus: {
        allUsersAccess: boolean;
        notifyAllUsersOnUpload: boolean;
        userAccessStatusList: UserAccessStatus[];
    };
    tags: Tag[];
}

export interface UserAccessStatus {
    userName: string;
    canHaveAccess: boolean;
    hasAccess: boolean;
    notifyOnUpload: boolean;
    userDetails: {
        username: string;
        firstName: string;
        lastName: string;
        image: string;
        projectsList: {
            project_id: number;
            project_name: string;
        }[];
    };
}
